// The reader's permission names where a conversation's posts live (shared/API.md §16.1) — what lets
// an admin edit or delete someone else's message (`core/messageEditRights`). Asked of the worker
// once per conversation; starts EMPTY, so the first frame offers exactly the own-post rule and
// never a row the server would refuse.
import { useEffect, useState } from 'react';
import { data } from '../../bridge/client';

const EMPTY: ReadonlySet<string> = new Set();

export function useConversationPermissions(channelId: string): ReadonlySet<string> {
  const [state, setState] = useState<{ channelId: string; permissions: ReadonlySet<string> }>({ channelId, permissions: EMPTY });
  useEffect(() => {
    if (!channelId) return;
    let live = true;
    data
      .call('conversationPermissions', channelId)
      .then((names) => {
        if (live) setState({ channelId, permissions: new Set(names) });
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [channelId]);
  // A switch must not show the previous conversation's grants for a frame.
  return state.channelId === channelId ? state.permissions : EMPTY;
}
